import DialogContentText from "@mui/material/DialogContentText";
import React from "react";

import GenericModal from "../../../components/modal-closebtn";
import { language } from "../../../language";

const BpmDeployModal = ({ openDialog, handleDialogClose, saveModel }) => {
  const handleCloseDialog = () => {
    handleDialogClose();
  };

  const handleSave = () => {
    saveModel();
    handleDialogClose();
  };

  return (
    <GenericModal
      title={language.modalDeployTitle}
      handleSubmit={() => handleSave()}
      handleClose={handleCloseDialog}
      btnActionTitle={language.confirm}
      btnCancelTitle={language.cancelDelete}
      size="xs"
      open={openDialog}
    >
      <DialogContentText className="text-center" id="alert-dialog-description">
        {language.modalDeployMessage}?
      </DialogContentText>
    </GenericModal>
  );
};

export { BpmDeployModal };
